import '.hq{overflow-x:auto;}.ssr-plugin'
import '.z{width:100%;}.ssr-plugin'
import { useTranslations } from '@i18n/useLanguage'
import { useEffect, useState } from 'react'
import { useClient, useQuery } from '@based/sdk/react'
import Column from '@app/components/layout/Column'
import { styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import Row from '@app/components/layout/Row'
import { MunicipalityCard } from '@app/components/blocks/card/MunicipalityCard'
import { ListMunicipalityModel } from 'functions/app/geography/list/municipality'
import { useLocation } from 'wouter'
import { pages } from '@app/util/links'

export const FeaturedSection = () => {
  const [, navigate] = useLocation()
  const translations = useTranslations().app.discoveryPage
  const client = useClient()
  const [mounted, setMounted] = useState(false)
  const [municipalities, setMunicipalities] = useState<ListMunicipalityModel[]>(
    [],
  )

  const dataServerQuery = useQuery('list-municipality', {
    featured: true,
    top: 5,
  })
  const serverMunicipalities: ListMunicipalityModel[] =
    dataServerQuery.data ?? []

  useEffect(() => {
    const close = client
      .query('list-municipality', { featured: true, top: 5 })
      .subscribe((result) => {
        setMunicipalities(result)
        setMounted(true)
      })
    return () => close()
  }, [client])

  const renderedMunicipalities = mounted ? municipalities : serverMunicipalities

  if (renderedMunicipalities.length === 0) {
    return null
  }

  return (
    <Column alignItems="stretch" style={{ width: '100%' }}>
      <Title.H3
        style={{
          alignSelf: 'start',
        }}
      >
        {translations.tabs.regions.featuredMunicipalitesTitle}
      </Title.H3>
      <Text.Medium>
        {translations.tabs.regions.featuredMunicipalitesSubtitle}
      </Text.Medium>
      <div className="hq z"
      >
        <Row
          gap="1rem"
          style={{
            width: 'max-content',
            flexWrap: 'nowrap',
            '&>*': {
              flex: '1 0 14rem',
              flexGrow: 0,
              flexShrink: 0,
            },
          }}
        >
          {renderedMunicipalities.map((municipality) => (
            <MunicipalityCard
              id={municipality.id}
              key={municipality.code}
              avatar={municipality.image?.src}
              title={municipality.name}
              plots={municipality.plots?.count ?? 0}
              hasBadge={true}
              initiatives={municipality.initiatives.count}
              avatars={municipality.followers ?? []}
              onClick={() =>
                navigate(pages.municipalityPage(municipality.slug))
              }
            />
          ))}
        </Row>
      </div>
    </Column>
  )
}
